module.exports = __webpack_public_path__ + "static/img_2004-189e91d1ab8be12af217b71b74f27e85.webp";